import { render, staticRenderFns } from "./BloodPressureMeasurements.vue?vue&type=template&id=943fa564&scoped=true"
import script from "./BloodPressureMeasurements.vue?vue&type=script&lang=js"
export * from "./BloodPressureMeasurements.vue?vue&type=script&lang=js"
import style0 from "./BloodPressureMeasurements.vue?vue&type=style&index=0&id=943fa564&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "943fa564",
  null
  
)

export default component.exports